import React from 'react';
import SignIn_Comp from '../../Components/SignIn/SignIn';

function Login() {
  return (
    <>
    <SignIn_Comp />
    </>
  )
}

export default Login;
